import React, { createRef } from 'react';
import './style.css';
//import { withRouter } from "react-router-dom";
import { Image, Card, ToggleButtonGroup, ToggleButton, Button, DropdownButton, Dropdown, Row, Col, Form } from 'react-bootstrap';
//import ReactTooltip from 'react-tooltip';
import sanitize from 'sanitize-filename';

import axios from 'axios';

import Select from 'react-select';

//import bsCustomFileInput from 'bs-custom-file-input';

//import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';

//import thumb_placeholder from 'Assets/thumb.svg';

import { local_routes } from 'utils/Routes';
import { apiUrl, org_friendly_url } from 'Api/Api';

import EventImg from 'Assets/event-img.jpg';

import UserContext from 'store/UserContext';

class LeafCard extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      leaf_type: '',
      leaf_asset_url: '',
      leaf_name: '',
      leaf_presentation_uuid: '',
      
      asset_name: '', // for display purposes
      leaf_asset_data: null, // for saving to API purposes
      
      leaf_type_pretty: '',
      presentation_options: [], // for leaf_type presentation_cover or presentation_video
      selected_presentation_option: null,

      validated: false,
      editing: false,
      loading: false,
      message: '',
      
      overlay_type: '',
      overlay_type_pretty: '',
      custom_overlay_description: ''
    };

    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
    
    this.leaf_form_ref = createRef();
    
    this.leaf_types = {
      image: {
        title: 'Image'
      },
      video: {
        title: 'Video'
      },
      presentation_cover: {
        title: 'PKCover'
      },
      presentation_video: {
        title: 'PKVideo'
      },
      event_cover: {
        title: 'EventCover'
      },
      /*
      event_cover: {
        title: 'Event Cover'
      }
      */
    };
    
    this.overlay_types = {
      event_cover: {
        smart: {
          title: 'Smart Overlay'
        },
        none: {
          title: 'No Overlay'
        },
        custom: {
          title: 'Custom Overlay'
        }
      },
      presentation_cover: {
        smart: {
          title: 'Smart Overlay'
        },
        none: {
          title: 'No Overlay'
        },
        custom: {
          title: 'Custom Overlay'
        }
      },
      image: {
        none: {
          title: 'No Overlay'
        },
        custom: {
          title: 'Custom Overlay'
        }        
      },
      /*
      event_cover: {
        smart: {
          title: 'Smart Overlay'
        },
        none: {
          title: 'No Overlay'
        },
        custom: {
          title: 'Custom Overlay'
        }
      },
      */
    }
    
    /*
    this.leaf_types = [
      {
        value: 'image',
        title: 'Image'
      },
      {
        value: 'video',
        title: 'Video'
      },
      {
        value: 'presentation_cover',
        title: 'PKCover',
        //linked_attribute: 'image_url'
      },
      {
        value: 'presentation_video',
        title: 'PKVideo',
        //linked_attribute: 'presentation_video_url'
      }
    ];
    */
  }

  resetLeafInfo = () => {
    let new_state = {...this.state};
    
    //let tmp_presentation_options = [];
    let tmp_selected_presentation_option = null;
    let tmp_selected_event_option = null;
    new_state.leaf_asset_url = this.props.leaf_info.leaf_asset_url || '';
    //let tmp_leaf_presentation_uuid = this.props.leaf_info.leaf_presentation_uuid || '';
    
    if (this.props.event_presentations_array) {
      let tmp_presentation_options = [];
      this.props.event_presentations_array.forEach( element => {
        let tmp_option = {
          value: element,
          label: element.entity_name
        }
        tmp_presentation_options.push(tmp_option);
        if (element.entity_uuid === this.props.leaf_info.leaf_presentation_uuid) {
          tmp_selected_presentation_option = tmp_option;
        }
      });
      new_state.selected_presentation_option = tmp_selected_presentation_option;
      new_state.presentation_options = tmp_presentation_options;
    }
    
    //let tmp_overlay_type_pretty = '';
    
    if (this.props.leaf_info.leaf_type === 'presentation_cover') {
      if (tmp_selected_presentation_option) {
        new_state.leaf_asset_url = tmp_selected_presentation_option.value.image_url;
      }
      if (this.props.leaf_info.leaf_presentation_cover_options) {
        if (this.props.leaf_info.leaf_presentation_cover_options.smart_overlay) {
          new_state.overlay_type = 'smart';
        } else if (this.props.leaf_info.leaf_presentation_cover_options.custom_overlay_description) {
          new_state.overlay_type = 'custom';
          new_state.custom_overlay_description = this.props.leaf_info.leaf_presentation_cover_options.custom_overlay_description;
        } else {
          new_state.overlay_type = 'none';
        }
      } else {
        new_state.overlay_type = 'smart';
      }
    } else if (this.props.leaf_info.leaf_type === 'event_cover') {
      // do we have event image?
      // order: spotlighted_image_url, image_urls, poster_image_url, thumb_image_url
      if (this.props.event_info.spotlighted_image_url) {
        new_state.leaf_asset_url = this.props.event_info.spotlighted_image_url;
      } else if (this.props.event_info.image_urls && this.props.event_info.image_urls.length > 0) {
        new_state.leaf_asset_url = this.props.event_info.image_urls[0];
      } else if (this.props.event_info.poster_image_url) {
        new_state.leaf_asset_url = this.props.event_info.poster_image_url;
      } else if (this.props.event_info.thumb_image_url) {
        new_state.leaf_asset_url = this.props.event_info.thumb_image_url;
      } else {
        new_state.leaf_asset_url = EventImg;
      }
      //console.log("event_cover",new_state.leaf_asset_url);
      
      if (this.props.leaf_info.leaf_event_cover_options) {
        if (this.props.leaf_info.leaf_event_cover_options.smart_overlay) {
          new_state.overlay_type = 'smart';
        } else if (this.props.leaf_info.leaf_event_cover_options.custom_overlay_description) {
          new_state.overlay_type = 'custom';
          new_state.custom_overlay_description = this.props.leaf_info.leaf_event_cover_options.custom_overlay_description;
        } else {
          new_state.overlay_type = 'none';
        }
      } else {
        new_state.overlay_type = 'smart';
      }
    } else if (this.props.leaf_info.leaf_type === 'image') {
      if (this.props.leaf_info.leaf_image_options) {
        if (this.props.leaf_info.leaf_image_options.custom_overlay_description) {
          new_state.overlay_type = 'custom';
          new_state.custom_overlay_description = this.props.leaf_info.leaf_image_options.custom_overlay_description;
        } else {
          new_state.overlay_type = 'none';
        }
      } else {
        new_state.overlay_type = 'none';
      }
    } else if (this.props.leaf_info.leaf_type === 'presentation_video') {
      if (tmp_selected_presentation_option) {
        new_state.leaf_asset_url = tmp_selected_presentation_option.value.presentation_video_url;
      }
    }
    
    //console.log("YO",this.props.leaf_info.leaf_type,new_state.overlay_type,this.overlay_types[this.props.leaf_info.leaf_type]);
    if (this.overlay_types[this.props.leaf_info.leaf_type]) {
      new_state.overlay_type_pretty = this.overlay_types[this.props.leaf_info.leaf_type][new_state.overlay_type].title
    }
    
    new_state.leaf_type_pretty = this.leaf_types[this.props.leaf_info.leaf_type].title;
    
    new_state.validated = false;
    
    new_state = {
      ...new_state,
      ...this.props.leaf_info,
    };
    
    this.setState(new_state);
    
    /*
    this.setState({
      ...this.props.leaf_info,
      leaf_asset_url: tmp_leaf_asset_url,
      leaf_type_pretty: this.leaf_types[this.props.leaf_info.leaf_type].title,
      overlay_type_pretty: 
      presentation_options: tmp_presentation_options,
      selected_presentation_option: tmp_selected_presentation_option
    });
    */
  }

  componentDidMount() {
    this.resetLeafInfo();
  }

  onChangeInputValue = (event) => {
    //console.log("myChangeHandler",event.target.id,event.target.value);
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  
  onChangeLeafType = (leaf_type) => {
    console.log("onChangeLeafType");
    let overlay_type = '';
    let overlay_type_pretty = '';
    if (this.overlay_types[leaf_type]) {
      overlay_type = Object.keys(this.overlay_types[leaf_type])[0];
      overlay_type_pretty = this.overlay_types[leaf_type][overlay_type].title;
    }
    
    let leaf_asset_url = '';
    if (leaf_type === 'event_cover') {
      if (this.props.event_info.spotlighted_image_url) {
        leaf_asset_url = this.props.event_info.spotlighted_image_url;
      } else if (this.props.event_info.image_urls && this.props.event_info.image_urls.length > 0) {
        leaf_asset_url = this.props.event_info.image_urls[0];
      } else if (this.props.event_info.poster_image_url) {
        leaf_asset_url = this.props.event_info.poster_image_url;
      } else if (this.props.event_info.thumb_image_url) {
        leaf_asset_url = this.props.event_info.thumb_image_url;
      } else {
        leaf_asset_url = EventImg;
      }
    }
    
    this.setState({
      overlay_type,
      overlay_type_pretty,
      leaf_type,
      leaf_type_pretty: this.leaf_types[leaf_type].title,
      leaf_asset_url,
      leaf_presentation_uuid: '',
      leaf_asset_data: null,
      asset_name: ''
    });
  }
  
  onChangeOverlayType = (overlay_type) => {
    console.log("onChangeOverlayType");
    this.setState({
      overlay_type,
      overlay_type_pretty: this.overlay_types[this.state.leaf_type][overlay_type].title,
      custom_overlay_description: '',
      validated: false
    });    
  }
  
  onChangeEditing = () => {
    console.log("onChangeEditing");
    let reset_state = {};
    if (this.state.editing) {
      // this is a cancel
      this.resetLeafInfo();
    }

    if (this.props.onEditing) {
      this.props.onEditing(this.props.leaf_info.leaf_index,!this.state.editing);
    }

    this.setState({
      editing: !this.state.editing,
      message: this.state.editing ? '' : 'Editing'
    });
    
  }
  
  onSaveLeaf = async () => {
    console.log("onSaveLeaf 1");
    
    if (this.leaf_form_ref.current.checkValidity() === false) {
      console.log("INVALID form");
      this.setState({
        validated: true
      });
      return;
    }
    
    if (!this.state.asset_name && !this.state.leaf_asset_url) {
      // invalid
      console.log("INVALID asset");
      this.setState({
        validated: true
      });
      return;
    }
    
    if (this.props.onSaveLeaf) {
      this.setState({
        loading: true
      });
      // if we have asset data, do getSignedUrl/PUT
      let tmp_leaf_asset_url = this.state.leaf_asset_url;
      
      if (this.state.leaf_asset_data) {
        let params = {
          asset_type: `runofshow_${this.state.leaf_type}s`,
          filename: this.state.asset_name
        }
        let asset_upload_data = await axios.post(`${apiUrl}events/${this.props.event_uuid}/getUploadSignedUrl`, {}, { params });
        let asset_length_bytes = this.state.leaf_asset_data.byteLength;
        const config = {
          headers: { "Content-Type": asset_upload_data.data.content_type },
          onUploadProgress: (progressEvent) => {
            let upload_percent = Math.floor(progressEvent.loaded / asset_length_bytes * 100);
            //console.log("ASSET UPLOADING PROGRESS",progressEvent.loaded,upload_percent);
            this.setState({
              message: 'Uploaded '+upload_percent+'%'
            });
          }
        };
        let uploadUrl = asset_upload_data.data.upload_url;
        tmp_leaf_asset_url = asset_upload_data.data.asset_url;
        await axios.put(uploadUrl, this.state.leaf_asset_data, config);
      }
      
      let leaf_info = {
        leaf_name: this.state.leaf_name,
        leaf_type: this.state.leaf_type
      }
      if (this.state.leaf_type === 'image' || this.state.leaf_type === 'video') {
        leaf_info.leaf_asset_url = tmp_leaf_asset_url || this.state.leaf_asset_url;
        leaf_info.leaf_presentation_uuid = "";
        if (this.state.leaf_type === 'image') {
          leaf_info.leaf_image_options = {};
          if (this.state.custom_overlay_description) {
            leaf_info.leaf_image_options.custom_overlay_description = this.state.custom_overlay_description;
          }
        }
      } else if (this.state.leaf_type === 'event_cover') {
        //leaf_info.leaf_presentation_uuid = this.state.selected_presentation_option.value.entity_uuid;
        //leaf_info.leaf_asset_url = "";
        delete leaf_info.leaf_asset_url;
        leaf_info.leaf_event_cover_options = {
          smart_overlay: this.state.overlay_type === 'smart' ? true : false,
        }
        if (this.state.custom_overlay_description) {
          leaf_info.leaf_event_cover_options.custom_overlay_description = this.state.custom_overlay_description;
        }
      } else if (this.state.leaf_type === 'presentation_cover' || this.state.leaf_type === 'presentation_video') {
        leaf_info.leaf_presentation_uuid = this.state.selected_presentation_option.value.entity_uuid;
        //leaf_info.leaf_asset_url = "";
        delete leaf_info.leaf_asset_url;
        if (this.state.leaf_type === 'presentation_cover') {
          leaf_info.leaf_presentation_cover_options = {
            smart_overlay: this.state.overlay_type === 'smart' ? true : false,
          }
          if (this.state.custom_overlay_description) {
            leaf_info.leaf_presentation_cover_options.custom_overlay_description = this.state.custom_overlay_description;
          }
        }
      }
      
      await this.props.onSaveLeaf(this.props.leaf_info.leaf_index,leaf_info);
    }
    this.setState({
      leaf_asset_data: '',
      loading: false,
      editing: false,
      message: 'Changes Saved'
    })
  }
  
  onRemoveLeaf = async () => {
    console.log("onRemoveLeaf",this.props.leaf_info.leaf_index);
    if (this.props.onRemoveLeaf) {
      await this.props.onRemoveLeaf(this.props.leaf_info.leaf_index);
    }
  }
  
  onChangeFile = async (event) => {
    console.log("onChangeFile",event.target.files);
    this.setState({
      loading: true
    });
    if (event.target.files[0]) {
      let file_name = event.target.files[0].name;
      
      // for saving to API
      let asset_data_array_buffer_promise = new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsArrayBuffer(event.target.files[0]);
        reader.onload = () => resolve(reader.result);
      });
      
      // for displaying preview
      let asset_data_url_promise = new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => resolve(reader.result);
      });

      let [asset_data_array_buffer,asset_data_url] = await Promise.all([asset_data_array_buffer_promise,asset_data_url_promise]);
      
      this.setState({
        leaf_asset_data: asset_data_array_buffer,
        leaf_asset_url: asset_data_url,
        asset_name: sanitize(file_name).replace(/[&\s]/g, '_').toLowerCase(),
        loading: false
      });
    }
  }
  
  getLeafMoveDropdownItems = () => {
    let content = [];
    for (let i = 0; i < this.props.leaf_count; i++) {
      if (i === this.props.leaf_info.leaf_index) {
        continue;
      }
      content.push(<Dropdown.Item key={i} onClick={() => this.onMoveLeaf(i)}>Move to position #{i+1}</Dropdown.Item>)
    }
    return content;
  }
  
  onMoveLeaf = (to_index) => {
    console.log("onMoveLeaf",this.props.leaf_info.leaf_index,to_index);
    if (this.props.onMoveLeaf) {
      this.props.onMoveLeaf(this.props.leaf_info.leaf_index,to_index);
    }
  }
  
  onDropdownPresentationChange = (selectedPresentationOption) => {
    console.log("onDropdownPresentationChange",selectedPresentationOption);
    if (!selectedPresentationOption) {
      return;
    }
    let tmp_leaf_asset_url = "";
    if (this.state.leaf_type === 'presentation_cover') {
      tmp_leaf_asset_url = selectedPresentationOption.value.image_url;
    } else if (this.state.leaf_type === 'presentation_video') {
      tmp_leaf_asset_url = selectedPresentationOption.value.presentation_video_url;
    }
    this.setState({
      selected_presentation_option: selectedPresentationOption,
      leaf_asset_url: tmp_leaf_asset_url
    });
  }
  
  render() {
    return (
      <Row style={{ paddingTop: "10px", paddingBottom: "10px" }} >
        <Col xs={2} className="align-self-center">
          <Row>
            <Col xs={3}><h2>{this.props.leaf_info.leaf_index+1}</h2></Col>
            <Col xs={9}>
              <DropdownButton
                size="sm"
                variant="pkprimary"
                title="Move Leaf"
                disabled={this.props.global_editing || this.props.global_playing}
              >
                {this.getLeafMoveDropdownItems()}
              </DropdownButton>
            </Col>
            </Row>
        </Col>
        <Col xs={10}>

          <Card
            bg={this.context.theme}
            text={this.context.theme === 'light' ? 'dark' : 'white'}
            //bg={!this.state.editing ? "light" : ""}
            border={this.state.editing ? "info" : "pkprimary"}
          >
            <Form
              ref={this.leaf_form_ref}
              noValidate
              validated={this.state.validated}
            >
            <Card.Header>
              <Row className="align-items-center justify-content-between">
                <Col xs={4}>
                    <Form.Group controlId={"leaf_name"+(this.state.editing ? '' : this.props.leaf_info.leaf_index)}>
                      <Form.Label>Leaf Name</Form.Label>
                      <Form.Control
                        disabled={!this.state.editing || this.state.loading}
                        placeholder="Enter Leaf Name"
                        value={this.state.leaf_name}
                        onChange={this.onChangeInputValue}
                        pattern=".{3,}"
                        maxLength={120}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                          Please enter a name between 3 and 120 characters long
                      </Form.Control.Feedback>
                    </Form.Group>

                </Col>
                <Col xs="5">
                  { (this.state.editing && !this.state.loading) ?
                    <ToggleButtonGroup
                      size="sm"
                      type="radio"
                      name="leaf_type"
                      value={this.state.leaf_type}
                      onChange={this.onChangeLeafType}
                    >
                      { Object.keys(this.leaf_types).map( leaf_type => (
                        <ToggleButton
                          key={leaf_type}
                          size="sm"
                          //disabled={!this.state.editing}
                          variant={this.context.theme === 'dark' ? "outline-light" : "outline-dark"}
                          //variant="outline-secondary"
                          value={leaf_type}
                        >
                          {this.leaf_types[leaf_type].title}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                    :
                    <Button
                      size="sm"
                      variant="secondary"
                      disabled
                    >
                      {this.state.leaf_type_pretty}
                    </Button>
                  }
                </Col>
    
                <Col xs="3">
                  { (this.props.leaf_info.leaf_name) &&
                    <ToggleButtonGroup
                      type="checkbox"
                      onChange={this.onChangeEditing}
                      style={{ marginRight: "3px" }}
                    >
                      <ToggleButton
                        disabled={this.state.loading || this.props.global_playing || (this.props.global_editing && !this.state.editing)}
                        variant="pkprimary"
                        checked={this.state.editing}
                        value="1"
                      >
                        {this.state.editing ? 'Cancel' : 'Edit'}
                      </ToggleButton>
                    </ToggleButtonGroup>
                  }
                  {this.state.editing &&
                    <React.Fragment>
                      <Button
                        variant="pkprimary"
                        onClick={this.onSaveLeaf}
                        style={{ marginRight: "3px" }}
                      >
                        {this.state.loading ? 'Saving...' : 'Save'}
                      </Button>
                      <Button
                        disabled={this.state.loading}
                        variant="danger"
                        onClick={this.onRemoveLeaf}
                        style={{ marginRight: "3px" }}
                      >
                        Delete
                      </Button>
                    </React.Fragment>
                  }
                </Col>            
              </Row>
              <Row className="align-items-center justify-content-between">
                <Col xs={12}>
                { this.overlay_types[this.state.leaf_type] &&
                  <React.Fragment>
                  { (this.state.editing && !this.state.loading) ?
                    <React.Fragment>
                      <Row>
                        <Col>
                          <ToggleButtonGroup
                            size="sm"
                            type="radio"
                            name="overlay_types"
                            value={this.state.overlay_type}
                            onChange={this.onChangeOverlayType}
                          >
                          { Object.keys(this.overlay_types[this.state.leaf_type]).map( overlay_type => (
                            <ToggleButton
                              key={overlay_type}
                              style={{ whiteSpace: 'nowrap' }}
                              size="sm"
                              //disabled={!this.state.editing}
                              //variant="outline-secondary"
                              variant={this.context.theme === 'dark' ? "outline-light" : "outline-dark"}
                              value={overlay_type}
                            >
                              {this.overlay_types[this.state.leaf_type][overlay_type].title}
                            </ToggleButton>
                          ))}
                          </ToggleButtonGroup>
                        </Col>
                      </Row>
                      { this.state.overlay_type === 'custom' &&
                      <Row style={{ marginTop: "10px" }} >
                        <Col>
                        <Form.Group controlId={"custom_overlay_description"+(this.state.editing ? '' : this.props.leaf_info.leaf_index)}>
                          <Form.Control
                              as="textarea"
                              value={this.state.custom_overlay_description}
                              onChange={this.onChangeInputValue}
                              placeholder="Enter Custom Overlay Text"
                              rows="3"
                              required
                              pattern=".{3,512}"
                              maxLength="512"
                          />
                          <Form.Control.Feedback type="invalid">
                              Please enter a description between 3 and 512 characters long
                          </Form.Control.Feedback>
                        </Form.Group>
                        </Col>
                      </Row>
                      }
                    </React.Fragment>
                    :
                    <Button
                      size="sm"
                      variant="secondary"
                      disabled
                    >
                      {this.state.overlay_type_pretty}
                    </Button>
                  }                
                  </React.Fragment>
                }
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Card.Title className="d-flex justify-content-between">
                <span>{this.state.leaf_type_pretty}</span>
                { this.state.message &&
                  <span style={{ color: "grey" }}>{this.state.message}</span>
                }
              </Card.Title>
              <Row>
                <Col xs={9}>
                  { (this.state.leaf_type === "image" || this.state.leaf_type === "video") &&
                    <Form.Group>
                      <Form.Label>1920x1080, 16:9 aspect ratio recommended</Form.Label>
                      <Form.File
                        id={"custom-file"+this.props.leaf_info.leaf_index}
                        custom={true}
                      >
                        <Form.File.Input
                          title={this.state.asset_name || 'Click to Upload '+this.state.leaf_type_pretty+' File'} // this handles the mouseover tooltip better
                          disabled={!this.state.editing || this.state.loading}
                          onChange={this.onChangeFile}
                          isInvalid={this.state.validated && !this.state.asset_name}
                          accept={this.state.leaf_type === "image" ? "image/*" : "video/*"}
                          ref={(ref) => this.uploadAssetRef = ref}
                        />
                        <Form.File.Label>{this.state.asset_name || 'Click to Upload '+this.state.leaf_type_pretty+' File'}</Form.File.Label>
                        <Form.Control.Feedback type="invalid">{this.state.leaf_type_pretty} file is required</Form.Control.Feedback>
                      </Form.File>
                    </Form.Group>
                  }
                  { (this.state.leaf_type === "presentation_cover" || this.state.leaf_type === "presentation_video") &&
                    <Select
                      isDisabled={!this.state.editing || this.state.loading}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, color: 'black', zIndex: 9999 }) }}
                      placeholder="Available Presentations..."
                      value={this.state.selected_presentation_option}
                      onChange={this.onDropdownPresentationChange}
                      options={this.state.presentation_options}
                  />
                  }
                </Col>
                <Col xs={3}>
                  { (this.state.leaf_type === 'image' && this.state.leaf_asset_url) &&
                    <Image
                      fluid
                      src={this.state.leaf_asset_url}
                      onClick={() => { this.uploadAssetRef.click() }}
                    />
                  }
                  { (this.state.leaf_type === 'event_cover' && this.state.leaf_asset_url) &&
                    <Image
                      fluid
                      src={this.state.leaf_asset_url}
                    />                  
                  }
                  { (this.state.leaf_type === 'presentation_cover' && this.state.leaf_asset_url) &&
                    <Image
                      fluid
                      src={this.state.leaf_asset_url}
                    />                  
                  }
                  { (this.state.leaf_type === 'video' && this.state.leaf_asset_url) &&
                    <video
                      src={this.state.leaf_asset_url}
                      onClick={() => { this.uploadAssetRef.click() }}
                    />
                  }
                  { (this.state.leaf_type === 'presentation_video' && this.state.leaf_asset_url) &&
                    <video
                      src={this.state.leaf_asset_url}
                    />
                  }
                </Col>
              </Row>
            </Card.Body>
            </Form>
          </Card>
          
        </Col>
      </Row>
    );
  }
  
}
export default LeafCard;